import { Component , EventEmitter, Input, OnInit, Output, TemplateRef } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { BsModalService } from 'ngx-bootstrap/modal';
import { Calibration_List_Interface, Empty_Calibration_List_Interface } from 'src/app/Interface/Calibration_List_Interface';
import { General_Interface } from 'src/app/Interface/General_Interface';
import { Empty_LetterRequestCustomer_Funds_Interface, LetterRequestCustomer_Funds_Interface } from 'src/app/Interface/LetterRequestCustomer_Funds_Interface';
import { Empty_User_Interface, User_Interface } from 'src/app/Interface/User_Interface';
import { AlertifyService } from 'src/app/Service/Alertify.service';
import { FundsService } from 'src/app/Service/Funds/Funds.service';
import { FundsTitleService } from 'src/app/Service/Funds/FundsTitle.service';
import { PriceService } from 'src/app/Service/Price/Price.service';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-FundsLetterForm',
  templateUrl: './FundsLetterForm.component.html',
  styleUrls: ['./FundsLetterForm.component.scss']
})
export class FundsLetterFormComponent implements OnInit {

  @Input() inner_Calibration: Calibration_List_Interface = Empty_Calibration_List_Interface()
  @Input() inner_Funds: LetterRequestCustomer_Funds_Interface = Empty_LetterRequestCustomer_Funds_Interface()
  @Output() OnBack_Calibration_Action = new EventEmitter<number>();
  InProccessing: boolean = false
  BaseUrl=environment.BaseUrl


  constructor(
    private Funds_Service: FundsService,
    private FundsTitle_Service: FundsTitleService,
    private Price_Service: PriceService,
    private modalService: BsModalService,
    private Alertify_Service:AlertifyService
  ) { }

  ngOnInit() {

    this.FundsForm=new FormGroup({
      id :new FormControl(),
      Title_Id:new FormControl(null,Validators.required),
      Price:new FormControl(null,Validators.required),
      Date:new FormControl(null,Validators.required),
      PriceAlpah:new FormControl(null),
      Dsc:new FormControl(null),
    })

    this.get_Form_Title_Id().setValue(this.inner_Funds.title_id)
    this.get_Form_Price().setValue(this.inner_Funds.price)
    this.get_Form_Date().setValue(this.inner_Funds.price_date)
    this.get_Form_Dsc().setValue(this.inner_Funds.dsc)
    this.pishPardakht_Change()

    if (this.inner_Funds.id==0)
      this.get_Form_Date().setValue(this.inner_Calibration.scheduleDate)

    this.Read_Title()
  }

  //#region  Form Add

    FundsForm:FormGroup;

    get_Form_Title_Id(){
      return this.FundsForm.get('Title_Id') as FormControl;
    }

    get_Form_Price(){
      return this.FundsForm.get('Price') as FormControl;
    }

    get_Form_PriceAlpah(){
      return this.FundsForm.get('PriceAlpah') as FormControl;
    }

    get_Form_Dsc(){
      return this.FundsForm.get('Dsc') as FormControl;
    }

    get_Form_Date(){
      return this.FundsForm.get('Date') as FormControl;
    }

    pishPardakht_Change() {
      this.Price_Service.GetPriceAlphabet(this.get_Form_Price().value).subscribe(
        data => {
          this.get_Form_PriceAlpah().setValue(data['price'])
        }
      )
    }

    InProccessing_Src:boolean=false
    uploadSrc(files) {
      if (files.length === 0)
        return;

      const formData = new FormData();

      for (const file of files) {
        formData.append(file.name, file);
      }

      this.InProccessing_Src=true

      this.Funds_Service.uploadFile(formData).subscribe(
        data=>{
          this.InProccessing_Src=false
          if(data['id']==0)
          {
            this.Alertify_Service.ErrorMessage(data['filename'])
          }
          else{
            this.Alertify_Service.SuccessMessage("فایل آپلود شد")
            this.inner_Funds.src=data['filename']
          }
        }
      )

    }

    Remove_uploadSrc(){
      this.inner_Funds.src=''
    }

    //#endregion

  OnSubmit() {

    if (!this.get_Form_Title_Id().value || this.get_Form_Title_Id().value == '0') {
      this.Alertify_Service.ErrorMessage("عنوان هزینه را انتخاب نمائید")
    }
    else  if (Number(this.get_Form_Price().value)<=0) {
      this.Alertify_Service.ErrorMessage("هزینه را وارد نمائید")
    }
    else {
      this.InProccessing = true
      this.Funds_Service.AddEditFunds_Schedule(
        this.inner_Funds.id,
        Number(this.inner_Calibration.letterRequestSchduleCustomer_id),
        Number(this.get_Form_Price().value),
        this.get_Form_Date().value,
        Number(this.get_Form_Title_Id().value),
        this.get_Form_Dsc().value,
        this.inner_Funds.src).subscribe(
        data => {
          this.InProccessing = false
          if (data == -1) {
            this.Alertify_Service.ErrorMessage("موجودی کافی برای ثبت این هزینه را ندارید.")
          }
          else {
            this.Alertify_Service.SuccessMessage("اطلاعات ثبت شد")

            if (this.inner_Funds.id == 0) {
              this.FundsForm.reset()
              this.get_Form_Title_Id().setValue("0")
            }
          }
        }, error => {
          // AuthInterceptor owns authentication; feature errors must preserve credentials.

        }
      )
    }
  }


  //#region Title

  DataList_Title:Array<General_Interface>=[]
  Read_Title() {
    this.FundsTitle_Service.GetActiveList().subscribe(
      data => {
        this.DataList_Title=data
      }, error => {
        // AuthInterceptor owns authentication; feature errors must preserve credentials.

      }
    )
  }

  //#endregion



}
